<template>
  <!-- Reference Sites Section -->
      <section class="relative py-16 overflow-hidden">
        <!-- Background Image with Color Overlay -->
        <div class="absolute inset-0">
          <img src="https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1755239931823.jpg" alt="พื้นหลังผลงานเว็บไซต์" class="w-full h-full object-cover">
          <div class="absolute inset-0 bg-gradient-to-r from-gray-50/90 via-blue-50/85 to-gray-100/90"></div>
        </div>
        
        <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center mb-12">
            <span class="inline-block bg-blue-100 text-blue-800 text-sm px-4 py-2 rounded-full font-semibold mb-6">
              ลูกค้าองค์กร (Corporate Clients)
            </span>
            <h2 class="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              องค์กรที่ใช้ระบบ
              <span class="text-blue-600">EcobzKM</span> อบรมพนักงาน
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
              ดูตัวอย่างองค์กรที่ใช้ระบบของเราในการพัฒนาทักษะพนักงาน แต่ละองค์กรมีรูปแบบการอบรมที่แตกต่างกัน
            </p>
          </div>

          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div
              v-for="item in references"
              :key="item.id"
              class="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group"
            >
              <div class="h-72 overflow-hidden relative">
                <img :src="item.image" :alt="`เว็บไซต์ ${item.title}`" loading="lazy" decoding="async" class="w-full h-full object-cover hover:scale-110 transition-transform duration-300">
                <div class="absolute top-3 right-3 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-medium">
                  {{ item.badge }}
                </div>
              </div>
              <div class="p-6">
                <div class="flex items-center justify-between mb-2">
                  <h4 class="text-lg font-semibold text-gray-900">{{ item.title }}</h4>
                  <div v-if="item.verified" class="flex items-center space-x-1">
                    <svg class="w-4 h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                    </svg>
                    <span class="text-xs text-blue-600 font-medium">Verified</span>
                  </div>
                </div>
                <p class="text-gray-600 mb-3">{{ item.description }}</p>
                <!-- <div class="grid grid-cols-2 gap-2 mb-4">
                  <div class="text-xs">
                    <span class="text-gray-500">Active Users:</span>
                    <span class="font-semibold text-gray-900"> {{ item.stats.activeUsers }}</span>
                  </div>
                  <div class="text-xs">
                    <span class="text-gray-500">Courses:</span>
                    <span class="font-semibold text-gray-900"> {{ item.stats.courses }}</span>
                  </div>
                  <div class="text-xs">
                    <span class="text-gray-500">Completion:</span>
                    <span class="font-semibold text-blue-600"> {{ item.stats.completion }}</span>
                  </div>
                  <div class="text-xs">
                    <span class="text-gray-500">Rating:</span>
                    <span class="font-semibold text-yellow-600"> {{ item.stats.rating }}</span>
                  </div>
                </div> -->
                <!-- <div class="flex items-center justify-between">
                  <span class="text-sm text-gray-500">อุตสาหกรรม: {{ item.industry }}</span>
                  <a :href="item.link || '#'" class="text-blue-600 hover:text-blue-800 font-semibold text-sm group-hover:underline">
                    ดูเว็บไซต์ →
                  </a>
                </div> -->
                
                <!-- Footer with hashtags and button -->
                <!-- <div class="mt-4 pt-4 border-t border-gray-100">
                  <div class="flex flex-wrap gap-1 mb-3">
                    <span v-for="tag in item.tags" :key="tag" class="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">#{{ tag }}</span>
                  </div>
                  <button class="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors">
                    ดูเว็บไซต์
                  </button>
                </div> -->
              </div>
            </div>
          </div>

          <div class="text-center mt-12">
            <button class="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
              ดูเคสศึกษาองค์กรอื่นๆ
            </button>
          </div>
        </div>
      </section>
</template>

<script setup>
// ข้อมูลเว็บไซต์อ้างอิง แก้ไข/เพิ่มได้ง่ายจากอาร์เรย์เดียว
const references = [
  {
    id: 'tech-corp',
    title: 'Kovic Academy',
    description: 'อบรมพนักงานภายในเกี่ยวกับกระบวนการผลิตในโรงงาน และมาตรฐานต่างๆภายในโรงงาน',
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/10/1760693675142.jpg',
    badge: 'Active 2 ปี',
    verified: true,
    stats: { activeUsers: '100 พนักงาน', courses: '45 คอร์ส', completion: '94%', rating: '4.8/5' },
    industry: 'Technology',
    tags: ['Programming', 'IT Skills', 'Corporate'],
    link: '#'
  },
  {
    id: 'manufacturing-corp',
    title: 'กรมวิชาการเกษตร',
    description: 'อบรมและรับรองหลักสูตรผู้ควบคุมการขายวัตถอันตรายทางการเกษตร',
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/10/1760693676201.jpg',
    badge: 'Active 3 ปี',
    verified: true,
    stats: { activeUsers: '20,000 ผู้อบรม', courses: '6 คอร์ส', completion: '91%', rating: '4.7/5' },
    industry: 'Manufacturing',
    tags: ['Safety', 'Quality', 'Manufacturing'],
    link: '#'
  },
  {
    id: 'retail-chain',
    title: 'FTI Academy',
    description: 'FTI Academy ศูนย์รวมหลักสูตรอบรม/สัมมนาภาคอุตสาหกรรม',
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/10/1760693675781.jpg',
    badge: 'Active 1.5 ปี',
    verified: true,
    stats: { activeUsers: '20,500 ผู้อบรม', courses: '140 คอร์ส', completion: '88%', rating: '4.6/5' },
    industry: 'Retail',
    tags: ['Sales', 'Customer Service', 'Retail'],
    link: '#'
  },
  {
    id: 'bank-corp',
    title: 'HR Fti Academy',
    description: 'อบรมพนักงานภายในสภาอุตสาหกรรม',
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/10/1760693676446.jpg',
    badge: 'Active 2.5 ปี',
    verified: true,
    stats: { activeUsers: '3,200 พนักงาน', courses: '55 คอร์ส', completion: '96%', rating: '4.9/5' },
    industry: 'Banking',
    tags: ['Finance', 'Compliance', 'Banking'],
    link: '#'
  },
  {
    id: 'hospital-group',
    title: 'หน่วยงาน Water Footprint',
    description: 'หลักสูตรที่ปรึกษาการประเมินวอเตอร์ฟุตพรินต์ (Water Footprint)',
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/10/1760693677103.jpg',
    badge: 'Active 4 ปี',
    verified: true,
    stats: { activeUsers: '5,800 พนักงาน', courses: '78 คอร์ส', completion: '93%', rating: '4.8/5' },
    industry: 'Healthcare',
    tags: ['Medical', 'Healthcare', 'Patient Care'],
    link: '#'
  },
  {
    id: 'logistics-corp',
    title: 'หน่วยงาน Eco Factory',
    description: 'หลักสูตรที่ปรึกษามาตรฐานโรงงานอุตสาหกรรมเชิงนิเวศ (Eco Factory)',
    image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/10/1760693676875.jpg',
    badge: 'Active 1 ปี',
    verified: true,
    stats: { activeUsers: '1,900 พนักงาน', courses: '25 คอร์ส', completion: '89%', rating: '4.7/5' },
    industry: 'Logistics',
    tags: ['Logistics', 'Warehouse', 'Transportation'],
    link: '#'
  }
]
</script>

<style scoped>
/* Any component-specific styles can be added here */
</style>
